import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/js/bootstrap.js';

import {API_BASE_URL} from './ConstantsAndHelper';

import {useState} from "react";
import Header from "./other/Header";
import Footer from "./other/Footer";
import Impressum from "./other/Impressum";
import Datenschutz from "./other/Datenschutz";
import CourseOverview from "./course/CourseOverview";
import AccessCourse from "./course/AccessCourse";
import ActualCourse from "./course/ActualCourse";
import Welcome from "./other/Welcome";
import Login from "./other/Login";

function App() {
    const [mainState, setMainState] = useState("welcome");
    const [actualCourse, setActualCourse] = useState(null);
    const [accessErrorText, setAccessErrorText] = useState("");
    const [encodedAuthHeader, setEncodedAuthHeader] = useState("");
    const [emailUser, setEmailUser] = useState("");
    const [verificationCode, setVerificationCode] = useState("");

    let mainHeader;
    if (mainState === "courseOverview") {
        mainHeader = <header><h1>Kurse</h1></header>;
    } else if (mainState === "login") {
        mainHeader = <header><h1>Login</h1></header>;
    } else if (mainState === "showCourse" || mainState === "accessCourse") {
        if (actualCourse.image !== null) {
            let image = <img src={"data:" + actualCourse.image.mimeType + ";base64," + actualCourse.image.content}
                             alt="" height="35"/>;
            mainHeader = <header><h1>{image}</h1><h1>{actualCourse.name}</h1></header>;
        } else {
            mainHeader = <header><h1>{actualCourse.name}</h1></header>;
        }
    } else {
        mainHeader = <header><h1>Quiz and Pass</h1><h3>Lernen - Üben - Bestehen</h3></header>;
    }

    let mainContent;
    if (mainState === "impressum") {
        mainContent = <Impressum/>;
    } else if (mainState === "datenschutz") {
        mainContent = <Datenschutz/>;
    } else if (mainState === "login") {
        mainContent = <Login emailUser={emailUser} setEmailUser={setEmailUser} setVerificationCode={setVerificationCode} setMainState={setMainState}/>;
    }else if (mainState === "courseOverview") {
        mainContent = <CourseOverview enterCourse={enterCourse} emailUser={emailUser} setEmailUser={setEmailUser} verificationCode={verificationCode} setVerificationCode={setVerificationCode}/>;
    } else if (mainState === "accessCourse") {
        mainContent = <AccessCourse actualCourse={actualCourse} accessCourse={accessCourse} accessErrorText={accessErrorText}/>;
    } else if (mainState === "showCourse") {
        mainContent = <ActualCourse actualCourse={actualCourse} encodedAuthHeader={encodedAuthHeader}/>;
    } else {
        mainContent = <Welcome/>;
    }

    function setMainToWelcome() {
        setMainState("welcome");
        setAccessErrorText("");
    }

    function setMainToImpressum() {
        setMainState("impressum");
        setAccessErrorText("");
    }

    function setMainToDatenschutz() {
        setMainState("datenschutz");
        setAccessErrorText("");
    }

    function setMainToCourseOverview() {
        setMainState("courseOverview");
        setActualCourse(null);
        setAccessErrorText("");
    }

    function setMainToActualCourse() {
        setMainState("showCourse");
    }

    function setMainToAccessCourse() {
        setMainState("accessCourse");
    }

    function setMainToLogin() {
        setMainState("login");
    }

    function setMainToLogout() {
        setMainState("welcome");
        setAccessErrorText("");
        setActualCourse(null);
        setEmailUser("");
        setVerificationCode("");
        performLogout();
    }

    function performLogout() {
        fetch(`${API_BASE_URL}/logout`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({email: emailUser.trim(), verificationCode: verificationCode.trim()})
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status.toString());
                } else {
                }
            })
            .catch((error) => {});
    }

    function accessCourse(course, rawAccessCode) {
        const courseId = course.id;
        setActualCourse(course);
        setMainToActualCourse();

        const base64EncodedAuthHeader = btoa(rawAccessCode + " " + emailUser.trim() + " " + verificationCode.trim());

        fetch(`${API_BASE_URL}/course/${courseId}`, {
            method: "GET",
            headers: {
                "Authorization": base64EncodedAuthHeader
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status.toString());
                } else {
                    setAccessErrorText("");
                    setEncodedAuthHeader(base64EncodedAuthHeader);
                    return response;
                }
            })
            .then(response => response.json())
            .then(data => setActualCourse(data))
            .catch((error) => {
                // console.log('error: ' + error);
                if(error.message === "401"){
                    setAccessErrorText("Der Verifizierungscode ist nicht korrekt oder abgelaufen. Bitte versuchen Sie den Login erneut.");
                    setEmailUser("");
                    setVerificationCode("");
                } else {
                    setAccessErrorText("Der eingegebene Zugangscode ist nicht richtig. Bitte versuchen Sie es erneut.");
                }
                setMainToAccessCourse();
            });
    }

    function enterCourse(course) {
        setActualCourse(course);
        setMainToAccessCourse();
    }

    return (
        <div className="App">
            <Header onClickWelcome={setMainToWelcome} onClickCourses={setMainToCourseOverview} onClickLogin={setMainToLogin} onClickLogout={setMainToLogout} emailUser={emailUser} verificationCode={verificationCode}/>

            <div className="container" id="mainContainer">
                <main className="main">
                    {mainHeader}
                    {mainContent}
                </main>
            </div>

            <Footer onClickImpressum={setMainToImpressum} onClickDatenschutz={setMainToDatenschutz}
                    onClickWelcome={setMainToWelcome}/>
        </div>
    );
}

export default App;